import { Navigate, useNavigate } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { ConsultationIntroScreen } from "~/patients/components";
import { useGetCurrentPatient } from "~/patients/hooks/queries/useGetCurrentPatient";
import { ROUTES } from "~/patients/router/routes";
import { PatientInformation } from "~/patients/utils";

const getIntakeIntroScreenMessage = (user?: PatientInformation) => (
  <div className="flex flex-col gap-4 text-base font-light text-gray-700">
    <p>Hi {user?.name}!</p>
    <p>
      The next step of your consultation is a detailed assessment that will help
      us better understand your story in order to focus our time on what matters
      most to you.
    </p>
    {user?.organization_patients[0]?.primary_provider && (
      <div className="space-y-0">
        <p>Warmly,</p>
        <p className="text-xl font-semibold">
          {user.organization_patients[0].primary_provider.signature_name}
        </p>
      </div>
    )}
  </div>
);

export const IntakeIntroScreen = () => {
  const navigate = useNavigate();
  const { data: user } = useGetCurrentPatient();

  if (user?.organization_patients[0].settings?.intake_first_screen_visited)
    return <Navigate to={ROUTES.completeIntakeConsultation} />;

  if (!user) {
    return <LoadingState className="h-screen" />;
  }

  const userAlreadySigned = Boolean(
    user.organization_patients[0].consent_signed_at,
  );

  const handleContinue = () => {
    if (!userAlreadySigned) {
      navigate(ROUTES.acknowledgeConsent);
    } else {
      navigate(ROUTES.payment);
    }
  };

  return (
    <ConsultationIntroScreen
      handleContinue={handleContinue}
      content={getIntakeIntroScreenMessage(user)}
      profilePicturePath={
        user?.organization_patients[0]?.primary_provider?.profile_picture_path
      }
    />
  );
};
